@if (game.hasPendingGamePlay()) {
<section>
  <div class="home">
    <img class="score-board-team-logo" alt="Logo {{ game.game.homeTeam.teamName }}"
      [ngSrc]="game.game.homeTeam.teamLogoUrl" width="90" height="90">
  </div>
  <div class="quart">
    <div class="score2">
      <div class="home" style="text-align: end;" tabindex="0" [class.current]="game.homeHasPossession()"
        (click)="toogleHomeScoreInput()" (keyup.enter)="toogleHomeScoreInput()">
        {{game.game.homeTeam.teamNameAbr}}
        <span class="_score">
          <span aria-hidden="true" (click)="toogleHomeScoreInput()">{{ game.getGame().homeScore }}</span>
        </span>
      </div>
      <div class="centre">|</div>
      <div style="text-align: start;" class="away" tabindex="0" [class.current]="game.awayHasPossession()"
        (click)="toogleAwayScoreInput()" (keyup.enter)="toogleAwayScoreInput()">
        <span class="_score">
          <span aria-hidden="true" (click)="toogleAwayScoreInput()">{{ game.getGame().awayScore }}</span>
        </span>
        {{game.game.awayTeam.teamNameAbr}}
      </div>
    </div>
    @if (game.game.gameStatus === GameStatus.InProgress) {
    <div class="quarter-box" (click)="changeQuarter()" (keyup)="changeQuarter()" tabindex="-1">
      <div [class.currentQuarter]="getQuarter() === 1" [class.previousQuarter]="getQuarter() > 1">1</div>
      <div [class.currentQuarter]="getQuarter() === 2" [class.previousQuarter]="getQuarter() > 2">2</div>
      <div [class.currentQuarter]="getQuarter() === 3" [class.previousQuarter]="getQuarter() > 3">3</div>
      <div [class.currentQuarter]="getQuarter() === 4" [class.previousQuarter]="getQuarter() > 4">4</div>
      @if (getQuarter() === 5) {
      <div [class.currentQuarter]="getQuarter() === 5">OT</div>
      }
    </div>
    }
    @if (game.game.gameStatus !== GameStatus.InProgress) {
    <div class="gameStatus">
      {{game.game.gameStatus}}
    </div>
    }
  </div>
  <div class="away visitors">
    <img class="score-board-team-logo" alt="Logo {{ game.game.awayTeam.teamName }}"
      [ngSrc]="game.game.awayTeam.teamLogoUrl" width="90" height="90">
  </div>
</section>
}

@if (game.isGamePending()) {
<app-current-action></app-current-action>
}